import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  setSelectedAccount,
  setGeneralMessage,
  setCurrentStep,
  submitAccountValidation,
  setSelectAccountOptions,
  saveToHistory,
} from '../changePhoneNumberSlice';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import SelectList from 'app/Components/Shared/SelectList/SelectList';
import useExtendedEffect from 'app/utilities/hooks/useExtendedEffect';

const SelectAccount = (props) => {
  const [error, setError] = useState(false);
  const [defaultSelectedOption, setDefaultSelectedOption] = useState(null);

  useEffect(() => {
    if (props.changePhoneNumber.selectAccountOptions.length == 0) {
      selectBoxOptions();
    }
  }, [props.productsAndServices]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        props.saveToHistory(props.changePhoneNumber.currentStep);
      }
    },
    [props.changePhoneNumber.selectedAccount],
  );

  function selectBoxOptions() {
    const options = [];
    props.selfcarePage?.subscribersByProduct?.Cellular?.map((phone, index) => {
      options.push({
        key: `${phone.productSubscriberNo} ${
          phone.productFirstName && phone.productLastName ? `- ${phone.productFirstName} ${phone.productLastName}` : ''
        }`,
        value: phone.productSubscriberNo,
      });
      if (phone.productSubscriberNo == props.selfcarePage.selectedSubscriber.productSubscriberNo) {
        setDefaultSelectedOption(phone.productSubscriberNo);
      }
    });
    props.setSelectAccountOptions(options);
    if (props.selfcarePage.selectedSubscriber) {
      props.setSelectedAccount(props.selfcarePage.selectedSubscriber);
    }
  }

  function submitAccountValidation() {
    if (props.changePhoneNumber.selectedAccount == null) {
      setError(true);
    } else {
      //validate selection
      props.submitAccountValidation({subscriberNo: props.changePhoneNumber.selectedAccount.productSubscriberNo});
    }
  }

  function setSelectedAccount(e) {
    const fullAccountData = props.selfcarePage?.subscribersByProduct?.Cellular?.find((phone) => phone.productSubscriberNo == e);
    props.setSelectedAccount(fullAccountData);
    setDefaultSelectedOption(e);
  }

  return (
    <div className='step select-account-step'>
      <div className='l-title'> לאיזה מנוי להחליף את המספר?</div>
      <div>
        <SelectList
          options={props.changePhoneNumber.selectAccountOptions}
          onClick={(e) => {
            setSelectedAccount(e);
          }}
          defaultValue={defaultSelectedOption}
        />
      </div>
      <div className='continue-button'>
        {error && <div className='error center'>כדי להמשיך יש לבחור מספר </div>}
        <BtnSubmit onclick={submitAccountValidation} text={'המשך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  changePhoneNumber: state.changePhoneNumber,
  selfcarePage: state.selfcarePage,
});

const mapDispatchToProps = {
  setSelectedAccount,
  setGeneralMessage,
  setCurrentStep,
  submitAccountValidation,
  setSelectAccountOptions,
  saveToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectAccount);
